import { useState } from "react";
import CategoryTree from "./CategoryTree";
import ClipArtList from "./ClipArtList";
import { ClipArt, ClipArtCategory } from "@/interfaces/clip-art.interface";
import { Splitter, SplitterPanel } from "primereact/splitter";

interface Props {
  onSelectCategory?: (category?: ClipArtCategory) => void;
  onSelectClipArt?: (clipArt?: ClipArt) => void;
  disableClone?: boolean;
}

export default function ClipArtManagement({
  onSelectCategory,
  onSelectClipArt,
  disableClone,
}: Props) {
  const [category, setCategory] = useState<ClipArtCategory>();

  const onChangeCategory = (category?: ClipArtCategory) => {
    setCategory(category);
    onSelectCategory?.(category);
  };

  return (
    <Splitter className="flex h-full w-full flex-1 overflow-auto">
      <SplitterPanel className="h-full w-1/4 max-w-[500px] min-w-[300px] overflow-auto border-r-1 border-gray-300">
        <CategoryTree onChange={onChangeCategory} disableClone={disableClone} />
      </SplitterPanel>
      <SplitterPanel className="h-full flex-1 overflow-auto">
        <ClipArtList category={category} onSelect={onSelectClipArt} />
      </SplitterPanel>
    </Splitter>
  );
}
